import React, { Component } from "react";
import {
  Typography,
  Box,
  IconButton,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Collapse,
  Alert,
  CardActionArea,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import ShareIcon from "@mui/icons-material/Share";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Serverurl from "./Apiurl";

class InvoiceView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusAnchor: null,
      status: "Status",

      emailDialogOpen: false,
      emailAddress: "",

      isSharing: false,
    };
  }

  // =========================
  // EDIT INVOICE
  // =========================
  handleEdit = () => {
    this.props.navigate("/Makeinvoice?edit=" + this.props.id);
  };

  // =========================
  // DUPLICATE INVOICE
  // =========================
  handleDuplicate = () => {
    this.props.navigate("/Makeinvoice?duplicate=" + this.props.id);
  };

  // =========================
  // EMAIL DIALOG
  // =========================
  openEmailDialog = () => {
    this.setState({
      emailDialogOpen: true,
      emailAddress: "",
    });
  };

  closeEmailDialog = () => {
    this.setState({
      emailDialogOpen: false,
    });
  };

  // =========================
  // SEND INVOICE EMAIL
  // =========================
  handleEmail = async () => {
    const emails = this.state.emailAddress
      ? this.state.emailAddress.trim()
      : "";

    const id = this.props.id;

    if (!emails) {
      alert("Please enter email address.");
      return;
    }

    const emailList = emails
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email);

    const invalidEmail = emailList.find(
      (email) => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    );

    if (invalidEmail) {
      alert("Invalid email address: " + invalidEmail);
      return;
    }

    const formdata = new FormData();

    formdata.append("action", "sendemail");
    formdata.append("in_id", id);
    formdata.append("in_type", 1);
    formdata.append("emails", emailList.join(","));

    try {
      const response = await axios.post(
        Serverurl + "ajaxinvoice.php",
        formdata
      );

      console.log("INVOICE EMAIL RESPONSE:", response.data);

      if (response.data.status === "success") {
        alert("Invoice sent successfully.");

        this.closeEmailDialog();
      } else {
        alert(
          response.data.message || "Email sending failed."
        );
      }
    } catch (error) {
      console.error("INVOICE EMAIL ERROR:", error);
      console.error(
        "SERVER RESPONSE:",
        error.response?.data
      );

      alert("Email sending failed.");
    }
  };

  // =========================
  // SHARE INVOICE PDF
  // =========================
  handleShare = async () => {
   const id = this.props.id;
        const pdfUrl = Serverurl + "uploads/Invoice-" + id + ".pdf";

this.setState({ isSharing: true });

try {
    if (navigator.share) {
        await navigator.share({
            title: "Invoice #" + this.props.id,
          text: "Here is the Invoice PDF document.",
         url: pdfUrl
        });
    } else {
        await navigator.clipboard.writeText(pdfUrl);
        alert("PDF link copied to clipboard.");
    }
} catch (error) {
    if (error.name !== "AbortError") {
        console.error("Share error:", error);
        await navigator.clipboard.writeText(pdfUrl);
        alert("PDF link copied to clipboard.");
    }
} finally {
    this.setState({ isSharing: false });
}

  };
  
  
 
// =========================
// SEND INVOICE WHATSAPP
// =========================
handleWhatsApp = async () => {
	let r = window.confirm("Please confirm to send on Whatsapp?");

    if (r === true) {
  const formData = new FormData();

  formData.append("action", "sendwhatsapp");
  formData.append("in_id", this.props.id);
  formData.append(
    "bu_id",
    localStorage.getItem("GBuserid")
  );
  formData.append("bu_name", localStorage.getItem("GBname"));

  try {
    const response = await axios.post(
      Serverurl + "ajaxinvoice.php",
      formData
    );

    console.log(
      "WHATSAPP RESPONSE:",
      response.data
    );

    if (response.data.status === "success") {
      alert(
        "Invoice sent successfully on WhatsApp."
      );
    } else {
      alert(
        response.data.message ||
        "WhatsApp sending failed."
      );
    }

  }
	  catch (error) {
    console.error(
      "WHATSAPP ERROR:",
      error
    );

    console.error(
      "SERVER RESPONSE:",
      error.response?.data
    );

    alert(
      error.response?.data?.message ||
      "WhatsApp sending failed."
    );
  }
  } 
};


  // =========================
  // STATUS MENU
  // =========================
  handleStatusClick = (event) => {
    this.setState({
      statusAnchor: event.currentTarget,
    });
  };

  handleStatusClose = () => {
    this.setState({
      statusAnchor: null,
    });
  };

  // =========================
  // UPDATE INVOICE STATUS
  // =========================
  handleStatusChange = (status) => {
    const id = this.props.id;

    const r = window.confirm(
      "Do you really want to update the status?"
    );

    if (r === true) {
      this.setState({
        status: status,
        statusAnchor: null,
      });

      const formData = new FormData();

      formData.append(
        "in_id[]",
        id
      );

      formData.append(
        "in_status",
        status
      );

      formData.append(
        "action",
        "invoicestatus"
      );

      axios
        .post(
          Serverurl + "ajaxinvoice.php",
          formData
        )
        .then((res) => {
          console.log(
            "STATUS RESPONSE:",
            res.data
          );

          if (
            String(res.data).trim() === "1"
          ) {
            alert(
              "Status Updated"
            );
          } else {
            alert(
              "Status Update Failed"
            );
          }
        })
        .catch((error) => {
          console.error(
            "STATUS ERROR:",
            error
          );

          alert(
            "Status Update Failed"
          );
        });
    } else {
      this.setState({
        statusAnchor: null,
      });
    }
  };

  // =========================
  // FINAL STATUS CHECK
  // =========================
  isStatusFinal = () => {
    return (
      this.state.status ===
        "Approved" ||
      this.state.status ===
        "Rejected"
    );
  };

  render() {
    const id = this.props.id;

    const params = new URLSearchParams(window.location.search);
    const source = params.get("source");

    let pdfUrl;

    if (source === "invoice") {
        pdfUrl =
            Serverurl +
            "uploads/Invoice-" +
            id +
            ".pdf";
    } else {
        pdfUrl =
            Serverurl +
      "makeinvoicepdf.php?in_id=" +
      id;
    }

    return (
        <>

    
        {/* =========================
            BACK BUTTON
        ========================== */}
        <ChevronLeftIcon
          className="global-back-arrow"
          onClick={() =>
            window.history.back()
          }
        />

        {/* =========================
            EMAIL DIALOG
        ========================== */}
        <Dialog
          open={
            this.state.emailDialogOpen
          }
          onClose={
            this.closeEmailDialog
          }
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            Send Invoice Email
          </DialogTitle>

          <DialogContent>
            <TextField
              label="Email Address"
              type="email"
              value={
                this.state.emailAddress
              }
              onChange={(e) =>
                this.setState({
                  emailAddress:
                    e.target.value,
                })
              }
              fullWidth
              margin="normal"
              placeholder="email@example.com"
              helperText="For multiple emails, separate them with commas."
            />

            <Box
              sx={{
                display: "flex",
                justifyContent:
                  "flex-end",
                gap: 1,
                mt: 2,
                mb: 1,
              }}
            >
              <Button
                variant="contained"
                sx={{
                  bgcolor:
                    "#103f86 !important",
                }}
                onClick={
                  this.closeEmailDialog
                }
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                sx={{
                  bgcolor:
                    "#103f86 !important",
                }}
                onClick={
                  this.handleEmail
                }
              >
                Send
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        {/* =========================
            INVOICE PDF
        ========================== */}
        <Box
          sx={{
            height: "100vh",
            position: "relative",
          }}
        >
             <iframe
    title="Invoice PDF"
    src={pdfUrl}
    style={{
        width: "100%",
        height: "calc(100% - 120px)",
        border: "none"
    }}
/>

          {/* =========================
              BOTTOM ACTION BAR
          ========================== */}
          <div className="sharingbuttons">
            <Box
              sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                background:
                  "#f0f4f7",
                display: "flex",
                justifyContent:
                  "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
                py: 1,
                px: 2,
                boxShadow:
                  "0 -2px 8px rgba(0,0,0,0.15)",
                zIndex: 1000,
                overflowX: "auto",

                "@media (max-width:600px)":
                  {
                    px: 0.1,
                    gap: 0.5,
                  },

                "& button": {
                  flexShrink: 0,
                },
              }}
            >
              {/* EDIT */}
              <Button
                variant="contained"
                onClick={
                  this.handleEdit
                }
                sx={{
                  bgcolor:
                    "#103f86",
                }}
              >
                <EditIcon />
              </Button>

              {/* DUPLICATE */}
              <Button
                variant="contained"
                onClick={
                  this.handleDuplicate
                }
                sx={{
                  bgcolor:
                    "#103f86",
                }}
              >
                <ContentCopyIcon />
              </Button>

              {/* SHARE */}
              <Button
                variant="contained"
                onClick={
                  this.handleShare
                }
                disabled={
                  this.state.isSharing
                }
                sx={{
                  bgcolor:
                    "#103f86 !important",
                }}
              >
                <ShareIcon />
              </Button>
			  
			  
			    	<Button
  variant="contained"
  onClick={this.handleWhatsApp}
  sx={{ bgcolor: '#103f86 !important' }}
>
  <WhatsAppIcon />
</Button>

              {/* EMAIL */}
              <Button
                variant="contained"
                color="primary"
                onClick={
                  this.openEmailDialog
                }
                sx={{
                  bgcolor:
                    "#103f86",
                }}
              >
                <EmailIcon />
              </Button>

              {/* STATUS */}
              <Button
                variant="contained"
                color={
                  this.state.status ===
                  "Approved"
                    ? "success"
                    : this.state.status ===
                      "Rejected"
                    ? "error"
                    : "warning"
                }
                startIcon={
                  <CheckCircleIcon />
                }
                onClick={
                  this.handleStatusClick
                }
                disabled={
                  this.isStatusFinal()
                }
                sx={{
                  bgcolor:
                    "#103f86",
                }}
              >
                {this.state.status}
              </Button>

              {/* STATUS MENU */}
              <Menu
                anchorEl={
                  this.state.statusAnchor
                }
                open={Boolean(
                  this.state.statusAnchor
                )}
                onClose={
                  this.handleStatusClose
                }
              >
                <MenuItem
                  onClick={() =>
                    this.handleStatusChange(
                      "Inprogress"
                    )
                  }
                >
                  Inprogress
                </MenuItem>

                <MenuItem
                  onClick={() =>
                    this.handleStatusChange(
                      "Approved"
                    )
                  }
                >
                  Approved
                </MenuItem>

                <MenuItem
                  onClick={() =>
                    this.handleStatusChange(
                      "Rejected"
                    )
                  }
                >
                  Rejected
                </MenuItem>
              </Menu>
            </Box>
          </div>
        </Box>
      </>
    );
  }
}

// =========================
// ROUTER WRAPPER
// =========================
function InvoiceViewWrapper() {
  const { id } = useParams();

  const navigate = useNavigate();

  return (
    <InvoiceView
      id={id}
      navigate={navigate}
    />
  );
}

export default InvoiceViewWrapper;
